/*
 * @Author: Teemo Ding
 * @Date: 2021-12-30 09:03:07
 * @LastEditTime: 2022-01-07 09:16:20
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/request/order/subscription.ts
 */
import {
  get, // post
  post,
  remove,
} from 'src/tools/server';
//import { EOperationType } from '@/src/types/common/order';

const getSubscriptionDetail = (orderUuid: string) => {
  return get<any>(`/portal/subscription/orderPage/${orderUuid}`, {});
};
const saveSubscriptionDetail = (data) => {
  return post<any>(`/portal/subscription/order`, data, {});
};

const getSubscriptionRecipient = (orderUuid: string) => {
  return get<any>(`/portal/subscription/order/${orderUuid}/recipient`, {});
};
const saveSubscriptionRecipient = (orderUuid: string, data: any) => {
  return post<any>(
    `/portal/subscription/order/${orderUuid}/recipient`,
    data,
    {},
  );
};
const cancelSubscription = (subscriptionOrderUuid) => {
  return remove<any>(`/portal/subscription/order/${subscriptionOrderUuid}`, {});
};

export {
  getSubscriptionDetail,
  saveSubscriptionDetail,
  getSubscriptionRecipient,
  saveSubscriptionRecipient,
  cancelSubscription,
};
